// components
import { MenuItem } from '@mui/material';
import GridPageAbstract from '../abstract/GridPageAbstract';
import Iconify from '../../components/iconify';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import i18n from '../../i18n';

/**
 * The proxies an xscraper gateway's browser goes out through, attached to a gateway
 * on its form. Core picks a random working one for every job and sets one aside
 * when a job fails through it; core-cron rechecks it every 5 minutes, putting it
 * back or, after 3 failed rechecks, removing it. So a list can change with nobody
 * editing it: Working and Failed count its proxies, a row's Proxies shows each one
 * with its failures, and the modified reason names a proxy core-cron removed.
 */
export default class ProxyListsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicProxyLists';
        this.Server = this.props.context.getState().server.publicProxyLists;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];
        this.showDatePicker = false;

        const defaultHead = [
            { id: 'name', required: true, label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
            {
                id: 'activeCount',
                label: 'activeCount',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'failedCount',
                label: 'failedCount',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                disableEditor: true
            },
            // One proxy per line, passwords included. Off the grid: a cell would
            // show the first line, credentials and all, to anyone looking at the
            // screen. The server stores it one canonical URL per line.
            {
                id: 'proxies',
                label: 'proxies',
                alignRight: false,
                cell: 'BigText',
                displayGrid: false,
                helperText: 'proxyListProxies'
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }

    openProxies = () => {
        const row = this.getMenuClickItem();
        this.handleCloseMenu();
        // ProxiesPage turns this into its list filter, shown as a removable chip.
        this.props.navigate('/app/proxies', {
            state: { proxyListId: row?.id }
        });
    };

    renderCustomMenuItems(id) {
        // An array, not a fragment: hasMenuItems counts custom items with
        // Array.isArray(...) && length > 0.
        if (!this.allowedPermission('read', 'publicProxies')) {
            return [];
        }
        return [
            <MenuItem key={`${id}-proxies`} onClick={this.openProxies}>
                <Iconify icon="eva:list-outline" sx={{ mr: 2 }} />
                {i18n.t('dialogs.proxyListProxies')}
            </MenuItem>
        ];
    }
}
